module.exports = "<ngx-ui-loader></ngx-ui-loader>\n<router-outlet></router-outlet>\n"